// 常量

export const ROUTES = {
    LOGIN: "login", // Login
    NOT_FOUND: "404", // NotFound
    FORBIDDEN: "403", // Forbidden
    SERVER_ERROR: "500", // ServerError
    ERROR_PAGE: "error-page", // ErrorPage

    DASHBOARD: "", // ダッシュボード
    MNT_COMPANY: "MntCompany", // 契約会社管理
    MNT_SITE: "MntSite", // 現場管理
    MNT_USER: "MntUser", // 安全責任者管理
    MNT_SENSOR: "MntSensor", // センサー管理
    MNT_OPERATOR: "MntOperator", // 操作員（端末）参照
    ENV_SETTINGS: "EnvSettings", // 環境設定
    PERSONAL_SETTINGS: "PersonalSetting", // 個人設定
    OPERATOR_DETAIL: "OperatorDetail", // 詳細情報
};

export const ROLES = {
    SYSTEM: "system", // システム管理者
    ADMIN: "admin", // 契約会社管理者
    GENERAL: "general", // 現場責任者
};

export const ALL = 'ALL'; // 
